import { Tooltip, TooltipContent, TooltipTrigger } from "../Tooltip/Tooltip"

export type IconDescriptionProps = {
    description: string,
    iconAccessibilityText: string,
    className?: string | undefined,
    icon: React.ForwardRefExoticComponent<React.PropsWithoutRef<React.SVGProps<SVGSVGElement>> & { title?: string, titleId?: string } & React.RefAttributes<SVGSVGElement>>
}

export function IconDescription(props: IconDescriptionProps) {
    return (
        <Tooltip>
            <TooltipTrigger>
                <div className={`flex flex-none gap-x-1 select-none text-contrast-tertiary ${props.className}`}>
                    <dt className="flex-none">
                        <props.icon className="h-5 w-5" aria-hidden="true" />
                    </dt>
                    <dd className="text-sm leading-6">
                        <span>{props.description}</span>
                    </dd>
                </div>
            </TooltipTrigger>
            <TooltipContent className="max-w-full w-96 px-4" style={{ zIndex: 100 }}>
                <div className="rounded-md bg-gray-900 border border-color-border/30 shadow p-4 text-sm text-white">
                    <div>{props.iconAccessibilityText}</div>
                </div>
            </TooltipContent>
        </Tooltip>
    )
}